var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGendepth(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 932,
    viewBox: "0 0 430 932",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4303_15668)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4303_15668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M587.195 377.992C587.195 1003.73 409.005 1510.99 189.195 1510.99C-30.6141 1510.99 -208.805 1003.73 -208.805 377.992C-208.805 -247.746 -30.614 -755.008 189.195 -755.008C409.005 -755.008 587.195 -247.746 587.195 377.992ZM450 519.5C450 441.203 420.275 370.647 372.721 321.097C373.564 314.021 374 306.813 374 299.5C374 203.679 299.455 126 207.5 126C115.545 126 41 203.679 41 299.5C41 306.179 41.3633 312.769 42.0683 319.252C-6.52778 368.888 -37.0001 440.226 -37.0001 519.5C-37.0001 669.445 72.0186 791 206.5 791C340.981 791 450 669.445 450 519.5Z",
    fill: "#0A150F",
    fillOpacity: 0.35,
    style: {
      mixBlendMode: "multiply"
    }
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4303_15668",
    x: -277.809,
    y: -824.013,
    width: 934.01,
    height: 2404.01,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34.5024,
    result: "effect1_foregroundBlur_4303_15668"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4303_15668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 430,
    height: 932,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGendepth);
export default __webpack_public_path__ + "static/media/gendepth.06d5485fd7872672dde8de8bc0cb98a6.svg";
export { ForwardRef as ReactComponent };